import { MoreHorizontal } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

/**
 * 2026-06 · 报价单操作（手机端）—— 桌面端一排导出按钮在手机上挤成一团，
 * 这里收进底部抽屉。actions: [{ key, label, icon, onClick, disabled }]
 */
export default function QuoteMobileActions({ actions }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const items = actions.filter(Boolean);
  if (!items.length) return null;

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}
        className="md:hidden ml-auto rounded-md" data-testid="quote-mobile-actions-button">
        <MoreHorizontal size={15} /> {t("quote.m.actions")}
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="max-h-[80vh] overflow-y-auto pb-[env(safe-area-inset-bottom)]"
          data-testid="quote-mobile-actions-sheet">
          <SheetHeader><SheetTitle>{t("quote.m.actions")}</SheetTitle></SheetHeader>
          <div className="mt-3 grid grid-cols-2 gap-2">
            {items.map(({ key, label, icon: Icon, onClick, disabled }) => (
              <button key={key} type="button" disabled={disabled}
                onClick={() => { setOpen(false); onClick(); }}
                data-testid={`quote-mobile-action-${key}`}
                className="h-14 rounded-md border border-border flex flex-col items-center justify-center gap-1 text-[11px] font-medium disabled:opacity-40 active:bg-secondary/50 transition-colors">
                <Icon size={17} className="text-brand" />
                <span className="truncate max-w-[90%]">{label}</span>
              </button>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
